import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import MenuItem from '@mui/material/MenuItem';
import Select from '@mui/material/Select';
import { ANCHORED_MENU_PROPS } from 'utils/muiSelectProps';
import { LanguageContext } from '../../LanguageProvider';

const localeItems = [
  {
    value: 'en',
    label: 'English (EN)',
  },
  {
    value: 'fr',
    label: 'Français (FR)',
  },
];

const VARIANT_SX = {
  // Authenticated TopBar (dark text on white)
  dark: {
    color: '#545959',
    fontSize: '15px',
    fontWeight: 400,
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
    },
    '& .MuiSelect-icon': {
      fill: 'grey',
    },
  },
  // Pre-auth / clinic chrome (light text)
  light: {
    color: 'white',
    fontSize: '14px',
    '& .MuiSelect-select:focus': {
      backgroundColor: 'transparent',
    },
    '& .MuiSelect-icon': {
      fill: 'white',
    },
  },
};

function LocaleSelect({
  appLocale = undefined,
  variant = 'dark',
  disableCurrentOption = false,
}) {
  return (
    <LanguageContext.Consumer>
      {({ locale, setLocale }) => {
        const value = appLocale || locale;
        return (
          <Select
            disableUnderline
            value={value}
            renderValue={v => v.toUpperCase()}
            IconComponent={KeyboardArrowDownIcon}
            MenuProps={ANCHORED_MENU_PROPS}
            sx={VARIANT_SX[variant] || VARIANT_SX.dark}
          >
            {localeItems.map(item => (
              <MenuItem
                key={item.value}
                value={item.value}
                onClick={() => setLocale(item.value)}
                disabled={disableCurrentOption && item.value === value}
              >
                {item.label}
              </MenuItem>
            ))}
          </Select>
        );
      }}
    </LanguageContext.Consumer>
  );
}

LocaleSelect.propTypes = {
  appLocale: PropTypes.string,
  variant: PropTypes.oneOf(['dark', 'light']),
  disableCurrentOption: PropTypes.bool,
};

function mapStateToProps(state) {
  return {
    appLocale: state.misc?.appLocale,
  };
}

export default connect(mapStateToProps)(LocaleSelect);
